/**
 * --------------------------------------------------------------------------
 * weblayout-navigation.js
 * Horizontal navigation dropdown hover functionality
 * --------------------------------------------------------------------------
 */

/**
 * Initialize Bootstrap dropdown hover behavior for horizontal navigation
 */
function initializeDropdownHover() {
  // Initialize Bootstrap dropdowns with hover behavior
  const dropdowns = document.querySelectorAll('.dropdown-hover [data-bs-toggle="dropdown"]');

  dropdowns.forEach(function(dropdown) {
    // Skip if already initialized
    if (dropdown.hasAttribute('data-dropdown-initialized')) {
      return;
    }

    const dropdownInstance = new bootstrap.Dropdown(dropdown, {
      autoClose: 'outside'
    });

    const dropdownParent = dropdown.closest('.dropdown-hover');
    const dropdownMenu = dropdownParent.querySelector('.dropdown-menu');

    // Show dropdown on hover
    dropdownParent.addEventListener('mouseenter', function() {
      dropdownInstance.show();
    });

    // Hide dropdown when mouse leaves both trigger and menu
    let hideTimeout;

    function scheduleHide() {
      hideTimeout = setTimeout(function() {
        dropdownInstance.hide();
      }, 100); // Small delay to prevent flickering
    }

    function cancelHide() {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
    }

    dropdownParent.addEventListener('mouseleave', scheduleHide);

    if (dropdownMenu) {
      dropdownMenu.addEventListener('mouseenter', cancelHide);
      dropdownMenu.addEventListener('mouseleave', scheduleHide);
    }

    // Prevent default click behavior for dropdown toggles without hrefs
    dropdown.addEventListener('click', function(e) {
      if (dropdown.getAttribute('href') === 'javascript:void(0);') {
        e.preventDefault();
      }
    });

    // Mark as initialized
    dropdown.setAttribute('data-dropdown-initialized', 'true');
  });
}

/**
 * Initialize nested dropdown hover behavior
 */
function initializeNestedDropdowns() {
  const nestedDropdowns = document.querySelectorAll('.dropend .dropdown-hover');

  nestedDropdowns.forEach(function(nestedDropdown) {
    const trigger = nestedDropdown.querySelector('[data-bs-toggle="dropdown"]');
    const menu = nestedDropdown.querySelector('.dropdown-menu');

    if (!trigger || !menu) {
      return;
    }

    // Skip if already initialized
    if (trigger.hasAttribute('data-nested-initialized')) {
      return;
    }

    const dropdownInstance = new bootstrap.Dropdown(trigger, {
      autoClose: 'outside'
    });

    let showTimeout, hideTimeout;

    nestedDropdown.addEventListener('mouseenter', function() {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }
      showTimeout = setTimeout(function() {
        dropdownInstance.show();
      }, 150); // Slight delay for better UX
    });

    nestedDropdown.addEventListener('mouseleave', function() {
      if (showTimeout) {
        clearTimeout(showTimeout);
      }
      hideTimeout = setTimeout(function() {
        dropdownInstance.hide();
      }, 150);
    });

    // Mark as initialized
    trigger.setAttribute('data-nested-initialized', 'true');
  });
}

/**
 * Initialize horizontal navigation dropdowns
 * This function can be called to reinitialize dropdowns after dynamic content changes
 */
export function initializeHorizontalNavigation() {
  // Check if Bootstrap is available
  if (typeof bootstrap === 'undefined' || !bootstrap.Dropdown) {
    console.warn('Bootstrap Dropdown not available. Skipping horizontal navigation initialization.');
    return;
  }

  // Initialize main dropdown hover behavior
  initializeDropdownHover();

  // Initialize nested dropdown behavior
  initializeNestedDropdowns();
}

/**
 * Reinitialize navigation after dynamic content updates
 * Useful when navigation items are added/removed dynamically
 */
export function reinitializeNavigation() {
  // Remove initialization markers
  document.querySelectorAll('[data-dropdown-initialized]').forEach(el => {
    el.removeAttribute('data-dropdown-initialized');
  });

  document.querySelectorAll('[data-nested-initialized]').forEach(el => {
    el.removeAttribute('data-nested-initialized');
  });

  // Reinitialize
  initializeHorizontalNavigation();
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', function() {
  initializeHorizontalNavigation();
});

// Also initialize when the module is imported
if (typeof window !== 'undefined') {
  // Make functions available globally for backward compatibility
  window.initializeHorizontalNavigation = initializeHorizontalNavigation;
  window.reinitializeNavigation = reinitializeNavigation;
}

// Export for ES6 modules
export default {
  initializeHorizontalNavigation,
  reinitializeNavigation
};